import firebase from "firebase"
import { dashboardRef, googleProvider, roomRef } from "./firebaseModel"


export const googleLogin = async()=>{
    return await firebase.auth().signInWithPopup(googleProvider);
}

export const addStudents = async(teacherID, students)=>{
    let studentsCollection =  dashboardRef.doc(teacherID).collection("Student");
    console.log("Students to be added: ",students)
    await setTimeout(2000);
    students.forEach(async(e)=>{
        console.log("ADDING STUDENTS",e)
        let data = await studentsCollection.add({
            name:e.trim(),
            answer:""
        })
        console.log(data)
    })

}

export const getStudents = async(teacherID) =>{
    let data = await dashboardRef.doc(teacherID).collection("Student").get();
    let studentsData = [];
    data.forEach(e=>{
        let studentObj = e.data();
        studentObj["id"] = e.id;
        studentsData.push(studentObj);
    })
    return studentsData;
}


export const isUserHaveStudent = async(teacherID) =>{
    let data = await dashboardRef.doc(teacherID).collection("Student").get();
    let hasData = false;
    data.forEach(e=>{
        hasData = true
    })
    return hasData;
}

export const deleteTeacherSession = async(teacherID) =>{
    try{
        let data= await dashboardRef.doc(teacherID).collection("Student").get();
        let ids=[]
        data.forEach(e=>{
            ids.push(e.id);
        })
        ids.forEach(async(elem)=>{
            await dashboardRef.doc(teacherID).collection("Student").doc(elem).delete()
        })
    }   
    catch(e){
        console.log("Deletion", e)
    }
}

export const getLink = async(teacherID) =>{
    try{
        let data = await roomRef.get();
        let roomID = "";
        data.forEach(e=>{
            if(e.data().teacherID === teacherID) roomID = e.id;
        })
        if(roomID===""){
            let newRoom = await roomRef.add({teacherID:teacherID});
            console.log("new Room",newRoom.id)
            roomID = newRoom.id;
        }
        return roomID
    }
    catch(e){
        console.log(e.message);
    }
}


export const getTeacherIDbyLink = async(link)=>{
    let data = await roomRef.doc(link).get();
    let teacherID = await data.data().teacherID;
    console.log("teacherID",teacherID)
    return teacherID
}

export const getStudentListDB = async (teacherID)=>{
    let data = await dashboardRef.doc(teacherID).collection("Student").get()
    let studentList = [];
    data.forEach(e=>{
        let newObj = e.data();
        newObj["id"] = e.id;
        studentList.push(newObj);
    })
    return studentList;
}


export const updateAnswer = async(teacherID,studentID,answer) =>{
    await dashboardRef.doc(teacherID).collection("Student").doc(studentID).update({
        answer:answer
    })
}

export const clearStudentAnswers = async(teacherID, students) =>{
    students.forEach(async(e)=>{
        await dashboardRef.doc(teacherID).collection("Student").doc(e.id).update({
            answer:""
        })
    })
}